import * as ID from '@/constants/identifier';
import * as C from '@/constants/colors';
import * as A from '@/constants/assets';
import { BOY_NAME, BOY_NAME_SHORT, GIRL_NAME, GIRL_NAME_SHORT, THE_BRIDE } from '.';

export const IMAGE_HELPER_LINK =
  'https://docs.google.com/document/d/1QyFatjHpGZVw9ZdpHC4ehokkRd11VrFycQi6ge24vME/edit?usp=sharing';
export const ASSETS_HELPER_LINK = '';

export const COLOR_DEFAULT_VALUES = [
  {
    colorCSS: 'bgPrimary',
    colorName: 'Background Utama',
    colorValue: C.BG_PRIMARY,
    colorSectionId: ID.ID_COUPLE_SECTION,
  },
  {
    colorCSS: 'bgSecondary',
    colorName: 'Background Sekunder',
    colorValue: C.BG_SECONDARY,
    colorSectionId: ID.ID_WISH_SECTION,
  },
  {
    colorCSS: 'bgAlternative',
    colorName: 'Background Alternatif',
    colorValue: C.BG_ALTERNATIVE,
    colorSectionId: ID.ID_RSVP_SECTION,
  },
  {
    colorCSS: 'mainColorText',
    colorName: 'Teks Utama',
    colorValue: C.TEXT_PRIMARY,
    colorSectionId: ID.ID_DETAIL_SECTION,
  },
  {
    colorCSS: 'secondaryColorText',
    colorName: 'Teks Sekunder',
    colorValue: C.TEXT_SECONDARY,
    colorSectionId: 'invitato-detail-content',
  },
  {
    colorCSS: 'mainColorTextLight',
    colorName: 'Teks Alternatif',
    colorValue: C.TEXT_PRIMARY_LIGHT,
    colorSectionId: ID.ID_GIFT_SECTION,
  },
];

export const IMAGES_DEFAULT_VALUES = [
  { imageConstant: 'BG_COVER', imageName: 'Background Cover', imageValue: A.BG_COVER },
  {
    imageConstant: 'BG_WELCOMING_SECTION',
    imageName: 'Background Cover Dalam',
    imageValue: A.BG_WELCOMING_SECTION,
  },
  { imageConstant: 'IMG_MAN', imageName: 'Foto Groom', imageValue: A.IMG_MAN },
  { imageConstant: 'IMG_GIRL', imageName: 'Foto Bride', imageValue: A.IMG_GIRL },
  {
    imageConstant: 'IMG_PHOTO_1',
    imageName: 'Foto Cover Luar Galeri 1',
    imageValue: A.IMG_PHOTO_1,
  },
  {
    imageConstant: 'IMG_PHOTO_2',
    imageName: 'Foto Cover Luar Galeri 2',
    imageValue: A.IMG_PHOTO_2,
  },
  {
    imageConstant: 'IMG_PHOTO_CONTENT',
    imageName: 'Foto Cover Dalam Galeri',
    imageValue: A.IMG_PHOTO_CONTENT,
  },
  {
    imageConstant: 'IMG_AYAT',
    imageName: 'Background Footer',
    imageValue: A.IMG_AYAT,
  },
  {
    imageConstant: 'BG_DESKTOP_VIEW',
    imageName: 'Background Desktop View',
    imageValue: A.BG_DESKTOP_VIEW,
  },
];

export const COUPLE_DEFAULT_VALUES = {
  coupleName: THE_BRIDE,
  brideName: GIRL_NAME_SHORT,
  groomName: BOY_NAME_SHORT,
  brideFullName: GIRL_NAME,
  groomFullName: BOY_NAME,
};

export const FONTS_DEFAULT_VALUES = [
  {
    fontCSS: 'heading',
    fontName: 'Heading',
    fontFamilyValue: 'Noto Serif Display',
    fontSizeValue: '36',
    fontWeightValue: '700',
    isFontItalic: false,
    fontCategory: 'heading',
    fontSectionId: ID.ID_DETAIL_SECTION,
  },
  {
    fontCSS: 'subHeading',
    fontName: 'Sub-heading',
    fontFamilyValue: 'Noto Serif Display',
    fontSizeValue: '26',
    fontWeightValue: '700',
    isFontItalic: false,
    fontCategory: 'heading',
    fontSectionId: ID.ID_DETAIL_SECTION,
  },
  {
    fontCSS: 'body',
    fontName: 'Body',
    fontFamilyValue: 'Tinos',
    fontSizeValue: '16',
    fontWeightValue: 'regular',
    isFontItalic: false,
    fontCategory: 'body',
    fontSectionId: ID.ID_DETAIL_SECTION,
  },
  {
    fontCSS: 'body_lv2',
    fontName: 'Body Alternatif',
    fontFamilyValue: 'Noto Serif Display',
    fontSizeValue: '18',
    fontWeightValue: '700',
    isFontItalic: false,
    fontCategory: 'body',
    fontSectionId: ID.ID_DETAIL_SECTION,
  },
  {
    fontCSS: 'fullName',
    fontName: 'Full Name',
    fontFamilyValue: 'Noto Serif Display',
    fontSizeValue: '26',
    fontWeightValue: '700',
    isFontItalic: false,
    fontCategory: 'body',
    fontSectionId: ID.ID_COUPLE_SECTION,
  },
];
